import { axios } from '@Root/API'

export const get = studentId => {
	return axios.get(`contacts-hesa/${studentId}`)
}
